import DeleteApproveSupplier from "@/v2/api/supplier/DeleteApprove";
import DeleteButton from "../general/Delete";

export default function ApproveSupplierDeleteButton({
    id,
    isInside = false,
}: {
    id: string;
    isInside?: boolean;
}) {
    return (
        <DeleteButton
            id={id}
            queryKey={["onboard-suppliers"]}
            deleteFn={DeleteApproveSupplier}
            title="Delete Onboard Request"
            description="Are you sure you want to delete onboard supplier request? This action cannot be undone. Click delete to confirm."
            successTitle="Supplier Request Deleted Successfully"
            isInside={isInside}
        />
    );
}
